import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { fetchBranchTransactionList } from "./branchTransactionThunks";
import BranchTransactionList from "./components/BranchTransactionList";

const { Title } = Typography;

const BranchTransactionEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { branchTransactions } = useSelector((state) => state.branchTransaction);

  useEffect(() => {
    dispatch(fetchBranchTransactionList());
  }, [dispatch]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="branch-transactions-back-button"
        />
        <Title level={2} style={{ margin: 0 }}>Branch Transactions</Title>
      </div>
      <BranchTransactionList branchTransactionList={branchTransactions} />
    </>
  );
};

export default BranchTransactionEntry;
